module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/xpro/Documentos/ances/myjangular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main